module.exports = __webpack_public_path__ + "img/cocktail-meatballs.8a59184b.jpg";